import React from "react"
import "./footer.css"

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-top">
        <div className="footer-section company-info">
          <p>© 2026 S. Huntley & Co. All rights reserved.</p>
          <p>Contact: <a href="mailto:david@bidderiq.com">david@bidderiq.com</a></p>
          <p>Made with 💻 in Pennsylvania</p>
        </div>

        <div className="footer-section links">
          <h4>Navigation</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="https://bidderiq.com/" target="_blank" rel="noopener noreferrer">Analytics</a></li>
            <li><a href="https://advertise.bidderiq.com/" target="_blank" rel="noopener noreferrer">Advertise</a></li>
            <li><a href="https://chromewebstore.google.com/detail/bidder-iq/nheiffajgnplomenmolhgfcmnkgdmjgm" target="_blank" rel="noopener noreferrer">Chrome Extension</a></li>
            <li><a href="https://stuttgartmarketletter.com" target="_blank" rel="noopener noreferrer">Stuttgart Market Letter</a></li>
          </ul>
        </div>

        <div className="footer-section compliance">
          <h4>Legal</h4>
          <ul>
            <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-of-service">Terms of Service</a></li>
            <li><a href="/do-not-sell">Do Not Sell My Personal Information</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>v3.0.0</p>
      </div>
    </footer>
  )
}

export default Footer
